// Formats français partagés par tous les écrans.
export function dateFr(v) {
  if (!v) return '';
  const s = String(v).slice(0, 10);
  const [a, m, j] = s.split('-');
  return a && m && j ? `${j}/${m}/${a}` : s;
}

export function dateHeureFr(v) {
  if (!v) return '';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export const ETATS = {
  accorde: { label: 'Accordé', classe: 'rg-etat--accorde' },
  refuse: { label: 'Refusé', classe: 'rg-etat--refuse' },
  retire: { label: 'Retiré', classe: 'rg-etat--retire' },
  expire: { label: 'Expiré', classe: 'rg-etat--expire' },
  inconnu: { label: 'Jamais demandé', classe: 'rg-etat--inconnu' },
};

export const SOURCES = {
  formulaire_sms: 'Formulaire (SMS)', formulaire_email: 'Formulaire (e-mail)', formulaire_web: 'Formulaire web',
  oral_appel: 'Oral (appel)', papier: 'Papier', operateur: 'Opérateur', import: 'Import', borne: 'Borne',
  stop_sms: 'STOP SMS', lien_retrait: 'Lien de retrait', systeme: 'Système',
};

export function n(v) { return new Intl.NumberFormat('fr-FR').format(Number(v) || 0); }
